import { useMemo } from 'react';
import { useTranslate } from '@shopify/ui-extensions-react/customer-account';
import { ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from '../utils/fileUpload';
import { UseFileUploadInstructionsProps, UseFileUploadInstructionsReturn } from '../types';

/**
 * @description Hook for the file upload instructions
 * @param seatRequirements - The seat requirements
 * @param maxFiles - The maximum number of files
 * @returns An object containing the instruction text and subtext
 */
export const useFileUploadInstructions = ({
  seatRequirements,
  maxFiles,
}: UseFileUploadInstructionsProps): UseFileUploadInstructionsReturn => {
  const translate = useTranslate();

  const instructionText = useMemo(() => {
    if (seatRequirements) {
      return translate('seatInstructions.dynamicInstructions', {
        totalPhotos: seatRequirements.totalPhotosRequired,
        summary: seatRequirements.instructionSummary,
      });
    }
    return translate('modal.instructions');
  }, [seatRequirements, translate]);

  const instructionSubtext = useMemo(() => {
    return translate('modal.instructionsSubtext', {
      maxFiles,
      formats: ACCEPTED_FILE_TYPES.join(', ').toUpperCase(),
      maxSize: MAX_FILE_SIZE / (1024 * 1024),
    });
  }, [maxFiles, translate]);

  return {
    instructionText,
    instructionSubtext,
  };
};

